module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("We hope you have enjoyed reading this book excerpt from the Center for Creative Leadership.  Please click on the store link to buy the book or a social link to share it.")]), _vm._v(" "), _c('p', [_vm._v("Here are other books that you might enjoy:")]), _vm._v(" "), _c('div', [_c('div', {
    staticStyle: {
      "width": "32.33%",
      "display": "inline-block",
      "margin": "0 1% 1% 0",
      "vertical-align": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://textcafe.co/books/Ary0yF/"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "https://s3.amazonaws.com/textcafe.epubs/uploads-image-covers/coresource/9781604916546.jpg",
      "width": "100%"
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "32.33%",
      "display": "inline-block",
      "margin": "0 1% 1% 0",
      "vertical-align": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://textcafe.co/books/p8zqgO/"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "https://s3.amazonaws.com/textcafe.epubs/uploads-image-covers/coresource/9781604918762.jpg",
      "width": "100%"
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "32.33%",
      "display": "inline-block",
      "margin": "0 1% 1% 0",
      "vertical-align": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://textcafe.co/books/Vjlkn7/"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "https://s3.amazonaws.com/textcafe.epubs/uploads-image-covers/coresource/9781604917321.jpg",
      "width": "100%"
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "32.33%",
      "display": "inline-block",
      "margin": "0 1% 1% 0",
      "vertical-align": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://textcafe.co/books/nbvuKH/"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "https://s3.amazonaws.com/textcafe.epubs/uploads-image-covers/coresource/9781604917314.jpg",
      "width": "100%"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d043112a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/last.vue
// module id = 102
// module chunks = 0